import { MILLISECONDS_PER_MINUTE } from '@/statics/timePeriods';

export const PAUSE_IN_MS_PROD = 15 * MILLISECONDS_PER_MINUTE;

export const PAUSE_IN_MS_DEV = 2 * MILLISECONDS_PER_MINUTE;

export default [PAUSE_IN_MS_PROD, PAUSE_IN_MS_DEV];
